module.exports = __webpack_public_path__ + "img/pad-logo.bd981a17.webp";